import NeonStage from "@/components/NeonStage";
import { Reveal } from "./Reveal";
import ClientsMarquee from "@/components/ClientsMarquee";
import "@/components/ClientsMarquee.css";

export const Clients = () => {
  return (
    <section id="clients" className="relative min-h-[230vh]" data-testid="clients-section">
      <div className="pin">
        <NeonStage variant="stars" />
        <div className="relative z-[1] w-full">
          <Reveal>
            <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#EE443E] mb-5">
              Клиенти
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2
              className="font-display uppercase text-4xl lg:text-[38px] mb-10 text-[var(--white)]"
              data-testid="clients-headline"
            >
              НАД 70 МАРКИ<br />ВЕЧЕ <span className="text-[var(--red)]">СВЕТЯТ</span> С НАС
            </h2>
          </Reveal>
          <ClientsMarquee />
        </div>
      </div>
    </section>
  );
};

export default Clients;
